import {
  TYPE_LOAD,
  TYPE_LOAD_SUCCESS,
  TYPE_ERROR,
  TYPE_SAVE,
  TYPE_SAVE_SUCCESS,
  TYPE_CLEAN,
  TYPE_DELETE,
  TYPE_DELETE_SUCCESS
} from "./actionTypes"

const initialState = {
  error: "",
  types: [],
  typesDelete: [],
  current: null,
  loading: false,
  success: false,
  loadingSave: false,
}

const type= (state = initialState, action) => {
  switch (action.type) {
    case TYPE_LOAD:
      state = {
        ...state,
        types: [],
        loading: true,
        success: false,
        current: null,
      }
      break
    case TYPE_LOAD_SUCCESS:
      state = {
        ...state,
        loading: false,
        success: true,
        error: "",
        types: action.payload,
      }
      break
    case TYPE_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        success: false,
        loadingSave: false,
      }
      break
    case TYPE_SAVE:
      state = {
        ...state,
        loadingSave: true,
        success: false,
        current: null,
      }
      break
    case TYPE_SAVE_SUCCESS:
      state = {
        ...state,
        loadingSave: false,
        success: true,
        error: "",
        current: action.payload,
      }
      break
    case TYPE_CLEAN:
      state = {
        ...state,
        current: null,
        loading: false,
        loadingSave: false,
        success: false,
        error: "",
      }
      break
    case TYPE_DELETE:
      state = {
        ...state,
        loading: true,
        success: false,
        typesDelete: [],
      }
      break
    case TYPE_DELETE_SUCCESS:
      state = {
        ...state,
        loading: true,
        success: true,
        error: "",
        typesDelete: action.payload,
      }
      break
  }
  return state
}

export default type
